<template>
    <div class="bg-white rounded-lg pt-3 pb-1 px-2
        flex flex-col justify-start justify-items-center items-center contact-height"
        >
        <div class="">
            <slot></slot>
        </div>
        <div class="text-20 text-blue-1 text-center pt-4 text-2-line" v-html="label">
        </div>
    </div>
</template>

<script>
import AuthStatusMixin from "@/mixin/AuthStatusMixin.js";
export default {
    name: 'GoToPageItem',
    mixins:[AuthStatusMixin],
    props: {
        label: { type: String, required: true },
    },
    methods: {
    }
}
</script>

<style lang="scss" scoped>
    .contact-height {
        height: 114px;
    }
</style>